module.exports = __webpack_public_path__ + "img/5_community-car-sp.9c2c66f7.gif";